import { useEffect } from 'react';
import { useSelf } from 'App/components/hooks/appHooks';
import { addNotification, STYLE as notificationStyle } from 'Store/reducers/SystemNotificationReducer';
import { useAppDispatch } from 'App/components/hooks';

export default function useMailCampaignAllowed() {
	const self = useSelf();
	const isAllowed = !!(self?.administrator || self?.userParams.mailAdmin);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (!isAllowed) {
			dispatch(
				addNotification({
					title: 'default.error',
					body: 'errorNotFound.mailCampaign',
					style: notificationStyle.ERROR,
					icon: 'times'
				})
			);
		}
	}, [isAllowed, dispatch]);

	return isAllowed;
}
